import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/gare.json"


import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
import DefaultDoughnutChart from "examples/Charts/DoughnutCharts/DefaultDoughnutChart";

import FileSystemGara from "./fileSystemGara.js"
import DettaglioGara from "./dettaglioGara.js"

import * as ajax from "helpers/ajax";

import { toPercentage } from "helpers/functions.js"
import { CHECKLIST_COMMESSA } from "../../constant.js";

const checklists = [
    {
        name: "Sopralluogo",
        type: "file&calendar"
    },
    {
        name: "Contributo anac",
        type: "file"
    },
    {
        name: "PassOe",
        type: "file"
    },
    {
        name: "Cauzione",
        type: "file"
    },
    {
        name: "Richiesta preparazione supporto esterno ",
        type: "file"
    },
    {
        name: "F23/F24/marche",
        type: "boolean"
    }
]

export default class Gare extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            listGara: [],
            garaSelected: null,
            openFileSystem: false,
            openDetail:false,
            yearSelected: new Date().getFullYear(),
        };


    }

    componentDidMount = () => {
        ajax.ajaxGetStrapi("garas?populate=*", this.loadCallback)
    }

    loadCallback = (response) => {
        this.setState({listGara:response.data})
    }

    graphRibassi = () => {

        let labels=["10%-", "10%-15%", "15%-20%", "20%-25%", "25%+"]
        let values = [0, 0, 0, 0, 0]; 

        this.state.listGara.map((el) => {
            if (el.discount_percentage < 10) { values[0]++; return }
            if (el.discount_percentage < 15) { values[1]++; return }
            if (el.discount_percentage < 20) { values[2]++; return }
            if (el.discount_percentage < 25) { values[3]++; return }
            values[4]++;
        })


        return {
            labels: labels,
            datasets: [{
                label: "label",
                color: "info",
                data: values,
            },],

        }
    }

    graphState = () => {

        let labels = ["Aggiudicata", "In lavorazione","Consegnata", "Respinta"]
        let values = [0, 0, 0, 0];

        this.state.listGara.map((el) => {
            if (el.status == labels[0]) { values[0]++; return }
            if (el.status == labels[1]) { values[1]++; return }
            if (el.status == labels[2]) { values[2]++; return }
            if (el.status == labels[3]) { values[3]++; return }
        })

        let tot = values[0] + values[1] + values[2] + values[3]

        return {
            labels:labels,
            datasets: {
                label: [toPercentage(values[0] / tot * 100), toPercentage(values[1] / tot * 100), toPercentage(values[2] / tot * 100), toPercentage(values[3] / tot * 100)],
                backgroundColors: ["success", "info", "error", "secondary"],
                data: values,
                titles: ["aa", "bb"],

            },
        }
    }


    graphAggiudicateRespinte = () => {
        let valuesAggiudicate = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        let valuesRespinte = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        this.state.listGara.map((el) => {
            if (new Date(el.end_date).getFullYear() == this.state.yearSelected) {
                if (el.status == "Aggiudicata") { valuesAggiudicate[new Date(el.end_date).getMonth()]++ }
                if (el.status == "Respinta") { valuesRespinte[new Date(el.end_date).getMonth()]++ }
            }
        })

        return {
            labels: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set","Ott","Nov","Dic"],
            datasets: [
                {
                    label: "Resipnte",
                    color: "secondary",
                    data: valuesRespinte,
                },
                {
                    label: "Aggiudicate",
                    color: "success",
                    data: valuesAggiudicate,
                },
            ],
        }

    }

    graphYearSelector = () => {
        return (
            <MDBox display={"flex"}>
                <MDButton onClick={() => this.setState({ yearSelected: this.state.yearSelected - 1 })}>{"<"}</MDButton>
                <MDTypography sx={{ flex: 1, textAlign: "center" }}>{this.state.yearSelected}</MDTypography>
                <MDButton onClick={() => this.setState({ yearSelected:this.state.yearSelected+1})}>{">"}</MDButton>
            </MDBox>
            )
    }

    createFileSystem = (data) => {
        let formData = new FormData();
        formData.append("id", data.data.id)
        ajax.ajaxPost("/file_create_gara.php", formData)
    }

    createChecklist = (data) => {
        checklists.map((el) => {
            let formdata = {}
            formdata["name"] = el.name;
            formdata["type"] = el.type;
            formdata["gara"] = data.data.id;
            formdata = { "data": formdata };
            ajax.ajaxPostStrapi("gara-checklists", formdata)
        })
    }

    createCommessa = (data, oldData) => {

        if (data.data.status != oldData.status && data.data.status == "Aggiudicata") {
            let amount_subjcet_to_discount_C = data.data.base_amount - data.data.security
            let amount_discounted_E = amount_subjcet_to_discount_C * data.data.discount_percentage / 100
            let importoProposto = amount_subjcet_to_discount_C - amount_discounted_E + data.data.security;


            let formdata = {}
            formdata["nome"] = data.data.name;
            formdata["durata"] = data.data.durata_offerta;
            formdata["preventivo"] = importoProposto;
            formdata["gara"] = data.data.id;
            formdata["costo_manodopera"] = data.data.costo_manodopera_preventivato;
            formdata["costo_ordini"] = data.data.costo_ordini_preventivato;
            formdata["stato"] = "in allestimento";
            formdata["committente"] = data.data.stazione_appaltante
            formdata["days_type"] = data.data.days_type
            formdata = { "data": formdata };
            this.GARAID=data.data.id
            ajax.ajaxPostStrapi("commessas", formdata, this.commessaCreated)
        }
    }

    commessaCreated = (response) => {
        let formData = new FormData();
        formData.append("id", response.data.id);
        formData.append("gara_id", this.GARAID) 
        this.GARAID = null;

        ajax.ajaxPost("/file_create_commessa.php", formData)

        
        CHECKLIST_COMMESSA.map((el) => {
            let formdata = {}
            formdata["name"] = el.name;
            formdata["type"] = el.type;
            formdata["commessa"] = response.data.id;
            formdata = { "data": formdata };
            ajax.ajaxPostStrapi("commessa-checklists", formdata)
        })

    }

    openFileSystem = (data) => {
        this.setState({ openFileSystem: true, garaSelected: data });
    }

    openDetail = (data) => {
        this.setState({ openDetail: true, garaSelected: data });
    }

    render() {
        if (this.state.garaSelected && this.state.openFileSystem) {
            return <FileSystemGara data={this.state.garaSelected} backFunction={() => this.setState({ garaSelected: null, openFileSystem: false })} />
        }

        if (this.state.garaSelected && this.state.openDetail) {
            return <DettaglioGara data={this.state.garaSelected} backFunction={() => this.setState({ garaSelected: null, openDetail: false })} />
        }

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Dashboard Gare"}
                    subtitle={"Vista globale dell'andamento delle gare"}
                    icon={"house"}
                />
                <Grid container>
                    <Grid item xs={12} md={6} lg={4} px={2} mt={3}>
                        <MDBox mb={3}>
                            <VerticalBarChart
                                icon={{ color: "info", component: "leaderboard" }}
                                title="Ribassi"
                                description="Numero di gare per valori di ribasso"
                                chart={this.graphRibassi()}
                                priceMode={false}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4} px={2} mt={3}>
                        <MDBox mb={3}>
                            <GradientLineChart
                                icon={{ color: "info", component: "leaderboard" }}
                                title="Gare aggiudicate e respinte"
                                description="Andamento nel tempo delle gare aggiudicate e di quelle respinte"
                                chart={this.graphAggiudicateRespinte()}
                                yearSelector={this.graphYearSelector()}
                                priceMode={false}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4} px={2} mt={3}>
                        <MDBox mb={3}>
                            <DefaultDoughnutChart
                                icon={{ color: "info", component: "leaderboard" }}
                                title="Stati"
                                description="Numero di gare per stato"
                                chart={this.graphState()}
                            />
                        </MDBox>
                    </Grid>
                </Grid>
                <MDBox>
                    <MyDataTable
                        tableData={tableData}
                        edit={true}
                        delete={true}
                        add={true}
                        icon={"Personale"}
                        onDelete={(data) => console.log("eliminato", data)}
                        onEdit={(data, oldData) => { this.createFileSystem(data); this.createCommessa(data, oldData)}}
                        onNew={(data) => { this.createFileSystem(data); this.createChecklist(data) }}
                        customAction={[
                            {
                                icon: "visibility",
                                function: this.openDetail
                            },
                            {
                                icon: "folder",
                                color: "info",
                                function: this.openFileSystem
                            }
                        ]}
                    />
                </MDBox>

            </DashboardLayout>
        )
    }
}


